import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-199" data-mp="3mf7pges1bkaz">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-200" data-mp="3r7905w9k12yw">
        <SectionTag icon="⭐" data-id="element-201" data-mp="3r9lp4tdqcdlg">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-202" data-mp="68z4tpuwoo">
          Entrenadores de toda España ya lo usan.
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-203" data-mp="91e45e0xrhej">
          <StarRating size={18} data-id="element-204" data-mp="9030rfbekbny" />
          <span className="text-sm text-muted" data-id="element-205" data-mp="e1ij2zm7442n">+500 reseñas verificadas</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-206" data-mp="2au2b9ygpaozl">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-white/10 bg-bg-secondary p-6" data-id="element-207" data-mp="2fslwtxrdtyrf" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-208" data-mp="1ete7lixngneu">
              <StarRating size={14} data-id="element-209" data-mp="1er1lctkuzqvz" />
              <span aria-hidden="true" data-id="element-210" data-mp="2bjx00zn0gke3">🇪🇸</span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-white/90" data-id="element-211" data-mp="2bh141guq45sa">"{t.text}"</p>
            <div className="mt-4 border-t border-white/10 pt-3" data-id="element-212" data-mp="26i7mndcbfumu">
              <p className="text-sm font-semibold text-white" data-id="element-213" data-mp="22he0opifopwl">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-214" data-mp="1xk5gykhn0dt8">{t.role}</p>
            </div>
          </m.div>)}
      </div>

      <p className="mt-6 text-center text-sm text-muted sm:text-base" data-id="element-215" data-mp="r4la3i1dq7i4">
        Más de <span className="font-semibold text-lime" data-id="element-216" data-mp="m3xnd8k6octp">9.000 entrenadores</span> en España ya entrenan con
        MISTER PRO: La Pizarra del Entrenador.
      </p>
    </section>;
}